import React from "react";

// import SkolkovoLogo from "../../assets/svg/SkolkovoLogo.svg";
import AbkrLogo from "../../assets/svg/AbkrLogo.svg";
import { MemberCard } from "../../components";

import styles from "./Membership.module.scss";

const organizations = [
  {
    id: 1,
    title: "Член Ассоциации Брендинговых Компаний России",
    site: "http://russianbranding.ru/members/",
    img: AbkrLogo,
  },
  // {
  //   id: 2,
  //   title: "Официальный маркетинг-провайдер",
  //   site: "https://sk.ru/marketing-services/",
  //   img: SkolkovoLogo,
  // },
];

const Membership = () => {
  return (
    <div className={styles.Membership}>
      {organizations.map((organization) => {
        return (
          <MemberCard
            key={organization.id}
            title={organization.title}
            link={organization.site}
            img={organization.img}
          />
        );
      })}
    </div>
  );
};

export default Membership;
